module.exports = __webpack_public_path__ + "img/icon@2x (2).331a69d7.png";